/**
 * Mobile app store URLs, badge assets, and the site-wide update banner cookie.
 *
 * Bump `MOBILE_APP_BANNER_COOKIE` (e.g. to `_v2`) to re-show the banner
 * after a new mobile-release notice.
 */

export const IOS_APP_STORE_URL =
  "https://apps.apple.com/ca/app/digital-aggregate/id6742847344";

export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.alterbiota.digitalaggregate";

export const IOS_APP_STORE_BADGE_SRC = "/help/mobile/apple-app-store-badge.png";

export const ANDROID_PLAY_STORE_BADGE_SRC =
  "/help/mobile/google-play-badge.png";

export const MOBILE_APP_BANNER_COOKIE = "da_mobile_app_banner_v1";
